export interface Project {
  id: string
  title: string
  sector: string
  countries: string[]
  status: 'active' | 'completed'
  description: string
  budget: string
  startDate: string
  endDate?: string
  featured?: boolean
}

export const projects: Project[] = [
  {
    id: '1',
    title: 'Africa Global Trade Partnership Initiative',
    sector: 'Trade & Investment',
    countries: ['Kenya', 'Nigeria', 'South Africa', 'Ghana'],
    status: 'active',
    description:
      'Strengthening trade relationships and facilitating investment flows between African nations and global markets through capacity building, trade missions, and regulatory harmonization in support of AfCFTA.',
    budget: '£15,000,000',
    startDate: '2025-01-01',
    endDate: '2027-12-31',
    featured: true,
  },
  {
    id: '2',
    title: 'African Health Systems Resilience Programme',
    sector: 'Health',
    countries: ['Ethiopia', 'Tanzania', 'Uganda', 'Rwanda'],
    status: 'active',
    description:
      'Building resilient health systems across Africa through infrastructure development, medical equipment provision, and healthcare worker training in partnership with international health agencies.',
    budget: '£22,500,000',
    startDate: '2024-06-01',
    endDate: '2027-05-31',
  },
  {
    id: '3',
    title: 'Digital Skills for Africa',
    sector: 'Education',
    countries: ['Senegal', "Côte d'Ivoire", 'Zambia', 'Botswana'],
    status: 'active',
    description:
      'A pan-African digital literacy and advanced tech skills training programme targeting 10,000 young Africans in collaboration with global technology partners.',
    budget: '£8,750,000',
    startDate: '2025-09-01',
    endDate: '2028-08-31',
    featured: true,
  },
  {
    id: '4',
    title: 'Climate-Smart Agriculture Initiative',
    sector: 'Agriculture',
    countries: ['Malawi', 'Zimbabwe', 'Mozambique'],
    status: 'active',
    description:
      'Promoting climate-resilient agricultural practices and technologies to improve food security and farmer incomes, supported by international climate funds.',
    budget: '£12,000,000',
    startDate: '2024-03-01',
    endDate: '2027-02-28',
  },
  {
    id: '5',
    title: 'Renewable Energy Access Programme',
    sector: 'Energy',
    countries: ['Sierra Leone', 'Liberia', 'Guinea'],
    status: 'active',
    description:
      'Expanding access to clean, affordable energy through solar mini-grids and off-grid solutions in rural communities, in partnership with global development finance institutions.',
    budget: '£18,500,000',
    startDate: '2025-04-01',
    endDate: '2028-03-31',
    featured: true,
  },
  {
    id: '6',
    title: 'Women in Business Accelerator',
    sector: 'Economic Development',
    countries: ['Nigeria', 'Kenya', 'Ghana', 'South Africa'],
    status: 'active',
    description:
      'Supporting women-led businesses across Africa through training, mentorship, and access to international finance networks.',
    budget: '£6,200,000',
    startDate: '2025-02-01',
    endDate: '2027-01-31',
  },
  {
    id: '7',
    title: 'Transport Infrastructure Modernization',
    sector: 'Infrastructure',
    countries: ['Tanzania', 'Kenya', 'Uganda'],
    status: 'active',
    description:
      'Upgrading cross-border transport infrastructure to facilitate regional trade, economic integration, and continental connectivity.',
    budget: '£45,000,000',
    startDate: '2024-01-01',
    endDate: '2028-12-31',
  },
  {
    id: '8',
    title: 'Global Diaspora Investment Platform',
    sector: 'Diaspora Engagement',
    countries: ['Pan-African'],
    status: 'active',
    description:
      'Connecting the African diaspora worldwide with investment, mentorship, and partnership opportunities across the continent.',
    budget: '£3,500,000',
    startDate: '2025-06-01',
    endDate: '2027-05-31',
  },
  {
    id: '9',
    title: 'Youth Employment Skills Programme',
    sector: 'Education',
    countries: ['Egypt', 'Morocco', 'Tunisia'],
    status: 'completed',
    description:
      'Vocational training and job placement programme for young people in North Africa, delivered with international vocational education partners.',
    budget: '£9,800,000',
    startDate: '2022-01-01',
    endDate: '2025-12-31',
  },
  {
    id: '10',
    title: 'Financial Inclusion Initiative',
    sector: 'Economic Development',
    countries: ['Burkina Faso', 'Mali', 'Niger'],
    status: 'active',
    description:
      'Expanding access to financial services across the Sahel through mobile banking, microfinance institutions, and global fintech partnerships.',
    budget: '£7,500,000',
    startDate: '2024-08-01',
    endDate: '2027-07-31',
  },
  {
    id: '11',
    title: 'Marine Conservation Partnership',
    sector: 'Environment',
    countries: ['Seychelles', 'Mauritius', 'Madagascar'],
    status: 'active',
    description:
      'Protecting marine ecosystems and promoting sustainable blue economy development in collaboration with international conservation bodies.',
    budget: '£11,200,000',
    startDate: '2025-01-01',
    endDate: '2028-12-31',
  },
  {
    id: '12',
    title: 'Pan-African Innovation Hubs Network',
    sector: 'Technology',
    countries: ['Rwanda', 'Kenya', 'Nigeria', 'South Africa'],
    status: 'active',
    description:
      'Establishing and supporting innovation hubs to foster tech entrepreneurship and startup growth, connecting African founders with global investors.',
    budget: '£5,800,000',
    startDate: '2024-10-01',
    endDate: '2027-09-30',
  },
]
